import * as React from "react";
import styled from "styled-components";
import Icon, { IconName } from "../Icon";
import { select } from "@hubper/theme";

const Base = styled.div<{ disabled?: boolean }>`
  display: inline-block;
  position: relative;
  color: ${p => select.color(["grey", p.disabled ? 1 : 9], p)};
  transition: ${select.speed("fast")};
  cursor: ${p => (p.disabled ? "default" : "pointer")};

  &:not(:last-child) {
    margin-right: ${select.space(2)};
  }

  &:hover {
    color: ${p => select.color(["grey", p.disabled ? 1 : 6], p)};
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  name: IconName;
  onClick?: () => void;
  disabled?: boolean;
};

function IconButton(
  { style, className, name, onClick, disabled }: Props,
  ref: any
) {
  return (
    <Base
      disabled={disabled}
      ref={ref}
      style={style}
      className={className}
      onClick={onClick}
    >
      <Icon name={name} size={17} />
    </Base>
  );
}

export default React.forwardRef(IconButton);
